import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the initiateRefundModalV2 state domain
 */

const selectInitiateRefundModalV2Domain = state =>
  state.initiateRefundModalV2 || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by InitiateRefundModalV2
 */

const makeSelectInitiateRefundModalV2 = () =>
  createSelector(
    selectInitiateRefundModalV2Domain,
    substate => substate,
  );

export default makeSelectInitiateRefundModalV2;
export { selectInitiateRefundModalV2Domain };
